import habitat from "preact-habitat";
import MainWidget from "./containers/MainWidget";
var _habitat = habitat(MainWidget);
_habitat.render({
    selector: '[data-widget-host="studenten-rating"]',
    clean: true
});
